$('.clients__slider').slick({
    rows: 0,
    arrows: false,
    dots: false,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    // cssEase: 'linear',
    centerMode: true,
    centerPadding: '0px',
    variableWidth: true,
    swipeToSlide: true,
    responsive: [{
        breakpoint: 991,
        settings: {
            slidesToShow: 5
        }
    },{
        breakpoint: 580,
        settings: {
            slidesToShow: 3
        }
    }]
});

$('.etalage').each(function () {
    const classControlActive = 'control--active';

    let $slider = $(this).find('.etalage__slider'),
        $controls = $(this).find('.etalage__controls');

    $slider.slick({
        rows: 0,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        pauseOnHover: true,
        adaptiveHeight: true,
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        // update active control button when slider moves
        $controls.find('.control').eq(nextSlide).addClass(classControlActive).siblings().removeClass(classControlActive);
    });

    // update slider when control button is clicked
    $controls.find('.control').on('click', function () {
        let index = $(this).index();

        $slider.slick('slickGoTo', index);
        $(this).addClass(classControlActive).siblings().removeClass(classControlActive);
    });
});